/* SS · Precios que convienen — entrada coordinada de las tarjetas.
   Un IntersectionObserver por seccion y nada mas: sin rAF, sin escuchar el
   scroll, sin recorrido nuevo y sin librerias. El estado oculto solo
   existe si el observador se construyo bien; ante la menor duda la seccion
   se queda visible y comprable. Las tarjetas son pulsables en todo momento:
   la entrada solo anima opacidad y desplazamiento. */
(function () {
  'use strict';
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  function init(el) {
    if (el.__sspc) return;
    el.__sspc = true;

    var io = null;
    var onVis = null;
    var onLoad = null;

    function cleanup() {
      if (io) { io.disconnect(); io = null; }
      if (onVis) { document.removeEventListener('visibilitychange', onVis); onVis = null; }
      if (onLoad) { window.removeEventListener('load', onLoad); onLoad = null; }
    }

    function reveal() {
      cleanup();
      el.setAttribute('data-sspc-in', '');
    }

    function cerca() {
      var r = el.getBoundingClientRect();
      var h = window.innerHeight || document.documentElement.clientHeight;
      return r.top < h * 1.1 && r.bottom > 0;
    }

    try {
      /* Si la seccion ya esta a la vista al arrancar -recarga a media
         pagina, ancla- no se oculta nada: se muestra tal cual. */
      if (cerca()) return;

      io = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) { reveal(); return; }
        }
      }, { threshold: 0.08, rootMargin: '0px 0px -6% 0px' });

      el.setAttribute('data-sspc-armed', '');
      io.observe(el);

      /* Cinturones: al volver a la pestana o al terminar la carga, si la
         seccion ya esta delante, se revela sin esperar al observador. */
      onVis = function () {
        if (document.visibilityState === 'visible' && cerca()) reveal();
      };
      onLoad = function () { if (cerca()) reveal(); };
      document.addEventListener('visibilitychange', onVis);
      window.addEventListener('load', onLoad);
    } catch (e) {
      cleanup();
      el.removeAttribute('data-sspc-armed');
    }
  }

  function boot() {
    var n = document.querySelectorAll('[data-sspc]');
    for (var i = 0; i < n.length; i++) init(n[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
